// Animation library shown in the Animate tab: Meshy's whole catalogue, mirrored
// from https://docs.meshy.ai/en/api/animation-library in its action_id order.
// Each LIBRARY row is [action_id, Meshy's clip name, preview file name] - the
// clip name is carried so a row can be checked against the docs table, and the
// file name is spelled out rather than derived from it so it cannot drift from
// what was uploaded to files.cgtrader.com. Tripo3D identifies a clip
// differently: it retargets onto one of its own named presets, so TRIPO_PRESETS
// maps every preset the Tripo3D schema accepts onto the Meshy clip that stands
// in for it, leaving no preset unreachable. Entries outside that map can only
// run on Meshy.
const PREVIEW_BASE_URL = 'https://files.cgtrader.com/public_files'

const TRIPO_PRESETS = {
  'Idle': 'preset:idle',
  'Idle_02': 'preset:idle',
  'Walking_Woman': 'preset:walk',
  'Run_02': 'preset:run',
  'RunFast': 'preset:run',
  'Jump_Run': 'preset:jump',
  'Attack': 'preset:slash',
  'Draw_and_Shoot_from_Back': 'preset:shoot',
  'BeHit_FlyUp': 'preset:hurt',
  'Fall1': 'preset:fall',
  'Idle_Turn_Left': 'preset:turn',
  'Ladder_Climb_Loop': 'preset:climb',
  'Dive_Down_and_Land': 'preset:dive',
}

const LIBRARY = [
  [0, 'Idle', 'idle'],
  [1, 'Walking_Woman', 'walking_woman'],
  [2, 'Alert', 'alert'],
  [3, 'Arise', 'arise'],
  [4, 'Attack', 'attack'],
  [5, 'BackLeft_run', 'back_left_run'],
  [6, 'BackRight_Run', 'back_right_run'],
  [7, 'BeHit_FlyUp', 'be_hit_fly_up'],
  [8, 'Dead', 'dead'],
  [9, 'ForwardLeft_Run_Fight', 'forward_left_run_fight'],
  [10, 'ForwardRight_Run_Fight', 'forward_right_run_fight'],
  [11, 'Idle_02', 'idle_02'],
  [12, 'Idle_03', 'idle_03'],
  [13, 'Jump_Run', 'jump_run'],
  [14, 'Run_02', 'run_02'],
  [15, 'Run_03', 'run_03'],
  [16, 'RunFast', 'run_fast'],
  [17, 'Skill_01', 'skill_01'],
  [18, 'Skill_02', 'skill_02'],
  [19, 'Skill_03', 'skill_03'],
  [20, 'Walk_Fight_Back', 'walk_fight_back'],
  [21, 'Walk_Fight_Forward', 'walk_fight_forward'],
  [22, 'FunnyDancing_01', 'funny_dancing_01'],
  [23, 'FunnyDancing_02', 'funny_dancing_02'],
  [24, 'FunnyDancing_03', 'funny_dancing_03'],
  [25, 'Agree_Gesture', 'agree_gesture'],
  [26, 'Angry_Stomp', 'angry_stomp'],
  [27, 'Big_Heart_Gesture', 'big_heart_gesture'],
  [28, 'Big_Wave_Hello', 'big_wave_hello'],
  [29, 'Call_Gesture', 'call_gesture'],
  [30, 'Casual_Walk', 'casual_walk'],
  [31, 'Catching_Breath', 'catching_breath'],
  [32, 'Chair_Sit_Idle_F', 'chair_sit_idle_f'],
  [33, 'Chair_Sit_Idle_M', 'chair_sit_idle_m'],
  [34, 'Checkout_Gesture', 'checkout_gesture'],
  [35, 'Clapping_Run', 'clapping_run'],
  [36, 'Confused_Scratch', 'confused_scratch'],
  [37, 'Discuss_While_Moving', 'discuss_while_moving'],
  [38, 'Dozing_Elderly', 'dozing_elderly'],
  [39, 'Excited_Walk_F', 'excited_walk_f'],
  [40, 'Excited_Walk_M', 'excited_walk_m'],
  [41, 'Formal_Bow', 'formal_bow'],
  [42, 'Gentlemans_Bow', 'gentlemans_bow'],
  [43, 'Handbag_Walk', 'handbag_walk'],
  [44, 'Happy_jump_f', 'happy_jump_f'],
  [45, 'Indoor_Play', 'indoor_play'],
  [46, 'Jump_Rope', 'jump_rope'],
  [47, 'Listening_Gesture', 'listening_gesture'],
  [48, 'Mirror_Viewing', 'mirror_viewing'],
  [49, 'Motivational_Cheer', 'motivational_cheer'],
  [50, 'Phone_Call_Gesture', 'phone_call_gesture'],
  [51, 'Shouting_Angrily', 'shouting_angrily'],
  [52, 'Sit_to_Stand_Transition_F', 'sit_to_stand_transition_f'],
  [53, 'Sit_to_Stand_Transition_M', 'sit_to_stand_transition_m'],
  [54, 'Squat_Stance', 'squat_stance'],
  [55, 'Stage_Walk', 'stage_walk'],
  [56, 'Stand_and_Chat', 'stand_and_chat'],
  [57, 'Stand_to_Sit_Transition_M', 'stand_to_sit_transition_m'],
  [58, 'Step_to_Sit_Transition', 'step_to_sit_transition'],
  [59, 'Victory_Cheer', 'victory_cheer'],
  [60, 'Walk_to_Sit', 'walk_to_sit'],
  [61, 'happy_jump_m', 'happy_jump_m'],
  [62, 'penguin_walk', 'penguin_walk'],
  [63, 'Arm_Circle_Shuffle', 'arm_circle_shuffle'],
  [64, 'All_Night_Dance', 'all_night_dance'],
  [65, 'Bass_Beats', 'bass_beats'],
  [66, 'Boom_Dance', 'boom_dance'],
  [67, 'Bubble_Dance', 'bubble_dance'],
  [68, 'Cherish_Pop_Dance', 'cherish_pop_dance'],
  [69, 'Crystal_Beads', 'crystal_beads'],
  [70, 'Cardio_Dance', 'cardio_dance'],
  [71, 'Denim_Pop_Dance', 'denim_pop_dance'],
  [72, 'Dont_You_Dare', 'dont_you_dare'],
  [73, 'Fast_Lightning', 'fast_lightning'],
  [74, 'Gangnam_Groove', 'gangnam_groove'],
  [75, 'Indoor_Swing', 'indoor_swing'],
  [76, 'Love_You_Pop_Dance', 'love_you_pop_dance'],
  [77, 'Magic_Genie', 'magic_genie'],
  [78, 'Not_Your_Mom', 'not_your_mom'],
  [79, 'OMG_Groove', 'omg_groove'],
  [80, 'Pop_Dance_LSA2', 'pop_dance_lsa2'],
  [81, 'Pod_Baby_Groove', 'pod_baby_groove'],
  [82, 'Shake_It_Off_Dance', 'shake_it_off_dance'],
  [83, 'Superlove_Pop_Dance', 'superlove_pop_dance'],
  [84, 'You_Groove', 'you_groove'],
  [85, 'Axe_Stance', 'axe_stance'],
  [86, 'Basic_Jump', 'basic_jump'],
  [87, 'Boxing_Practice', 'boxing_practice'],
  [88, 'Chest_Pound_Taunt', 'chest_pound_taunt'],
  [89, 'Combat_Stance', 'combat_stance'],
  [90, 'Counterstrike', 'counterstrike'],
  [91, 'Double_Blade_Spin', 'double_blade_spin'],
  [92, 'Double_Combo_Attack', 'double_combo_attack'],
  [93, 'Dodge_and_Counter', 'dodge_and_counter'],
  [94, 'Flying_Fist_Kick', 'flying_fist_kick'],
  [95, 'Gun_Hold_Left_Turn', 'gun_hold_left_turn'],
  [96, 'Kung_Fu_Punch', 'kung_fu_punch'],
  [97, 'Left_Slash', 'left_slash'],
  [98, 'Run_and_Shoot', 'run_and_shoot'],
  [99, 'Reaping_Swing', 'reaping_swing'],
  [100, 'Rightward_Spin', 'rightward_spin'],
  [101, 'Sword_Shout', 'sword_shout'],
  [102, 'Sword_Judgment', 'sword_judgment'],
  [103, 'Simple_Kick', 'simple_kick'],
  [104, 'Side_Shot', 'side_shot'],
  [105, 'Triple_Combo_Attack', 'triple_combo_attack'],
  [106, 'Confident_Walk', 'confident_walk'],
  [107, 'Confident_Strut', 'confident_strut'],
  [108, 'Flirty_Strut', 'flirty_strut'],
  [109, 'Groovy_Walk', 'groovy_walk'],
  [110, 'Hello_Run', 'hello_run'],
  [111, 'Injured_Walk', 'injured_walk'],
  [112, 'Monster_Walk', 'monster_walk'],
  [113, 'Mummy_Stagger', 'mummy_stagger'],
  [114, 'Proud_Strut', 'proud_strut'],
  [115, 'Quick_Walk', 'quick_walk'],
  [116, 'Run_to_Walk_Transition', 'run_to_walk_transition'],
  [117, 'Red_Carpet_Walk', 'red_carpet_walk'],
  [118, 'Skip_Forward', 'skip_forward'],
  [119, 'Slow_Orc_Walk', 'slow_orc_walk'],
  [120, 'Touch_and_Run', 'touch_and_run'],
  [121, 'Thoughtful_Walk', 'thoughtful_walk'],
  [122, 'Texting_Walk', 'texting_walk'],
  [123, 'Unsteady_Walk', 'unsteady_walk'],
  [124, 'Walking_with_Phone', 'walking_with_phone'],
  [125, 'Charged_Spell_Cast', 'charged_spell_cast'],
  [126, 'Charged_Spell_Cast_1', 'charged_spell_cast_1'],
  [127, 'Charged_Ground_Slam', 'charged_ground_slam'],
  [128, 'Heavy_Hammer_Swing', 'heavy_hammer_swing'],
  [129, 'mage_soell_cast', 'mage_soell_cast'],
  [130, 'mage_soell_cast_1', 'mage_soell_cast_1'],
  [131, 'mage_soell_cast_2', 'mage_soell_cast_2'],
  [132, 'mage_soell_cast_3', 'mage_soell_cast_3'],
  [133, 'mage_soell_cast_4', 'mage_soell_cast_4'],
  [134, 'mage_soell_cast_5', 'mage_soell_cast_5'],
  [135, 'mage_soell_cast_6', 'mage_soell_cast_6'],
  [136, 'mage_soell_cast_7', 'mage_soell_cast_7'],
  [137, 'mage_soell_cast_8', 'mage_soell_cast_8'],
  [138, 'Block1', 'block1'],
  [139, 'Block2', 'block2'],
  [140, 'Block3', 'block3'],
  [141, 'Block4', 'block4'],
  [142, 'Block5', 'block5'],
  [143, 'Block6', 'block6'],
  [144, 'Block8', 'block8'],
  [145, 'Block9', 'block9'],
  [146, 'Block10', 'block10'],
  [147, 'Sword_Parry', 'sword_parry'],
  [148, 'Sword_Parry_Backward', 'sword_parry_backward'],
  [149, 'Two_Handed_Parry', 'two_handed_parry'],
  [150, 'Hit_Reaction_with_Bow', 'hit_reaction_with_bow'],
  [151, 'Sword_Parry_Backward_1', 'sword_parry_backward_1'],
  [152, 'Sword_Parry_Backward_2', 'sword_parry_backward_2'],
  [153, 'Sword_Parry_Backward_3', 'sword_parry_backward_3'],
  [154, 'Sword_Parry_Backward_4', 'sword_parry_backward_4'],
  [155, 'Sword_Parry_Backward_5', 'sword_parry_backward_5'],
  [156, 'Stand_Dodge', 'stand_dodge'],
  [157, 'Stand_Dodge_1', 'stand_dodge_1'],
  [158, 'Roll_Dodge', 'roll_dodge'],
  [159, 'Roll_Dodge_1', 'roll_dodge_1'],
  [160, 'Roll_Dodge_2', 'roll_dodge_2'],
  [161, 'Roll_Dodge_3', 'roll_dodge_3'],
  [162, 'Stand_Dodge_2', 'stand_dodge_2'],
  [163, 'Roll_Dodge_4', 'roll_dodge_4'],
  [164, 'Stand_Dodge_3', 'stand_dodge_3'],
  [165, 'Kneeling_Reload', 'kneeling_reload'],
  [166, 'Running_Reload', 'running_reload'],
  [167, 'Slow_Walk_Reload', 'slow_walk_reload'],
  [168, 'Prone_Reload', 'prone_reload'],
  [169, 'Forward_Reload_Subtle', 'forward_reload_subtle'],
  [170, 'Standing_Reload', 'standing_reload'],
  [171, 'Hit_Reaction_to_Waist', 'hit_reaction_to_waist'],
  [172, 'Electrocution_Reaction', 'electrocution_reaction'],
  [173, 'Slap_Reaction', 'slap_reaction'],
  [174, 'Face_Punch_Reaction', 'face_punch_reaction'],
  [175, 'Face_Punch_Reaction_1', 'face_punch_reaction_1'],
  [176, 'Face_Punch_Reaction_2', 'face_punch_reaction_2'],
  [177, 'Gunshot_Reaction', 'gunshot_reaction'],
  [178, 'Hit_Reaction', 'hit_reaction'],
  [179, 'Hit_Reaction_1', 'hit_reaction_1'],
  [180, 'Shot_in_the_Back_and_Fall', 'shot_in_the_back_and_fall'],
  [181, 'Electrocuted_Fall', 'electrocuted_fall'],
  [182, 'Shot_and_Blown_Back', 'shot_and_blown_back'],
  [183, 'Shot_and_Fall_Backward', 'shot_and_fall_backward'],
  [184, 'Shot_and_Fall_Forward', 'shot_and_fall_forward'],
  [185, 'Shot_and_Slow_Fall_Backward', 'shot_and_slow_fall_backward'],
  [186, 'Strangled_and_Fall_Forward', 'strangled_and_fall_forward'],
  [187, 'Knock_Down', 'knock_down'],
  [188, 'Fall_Dead_from_Abdominal_Injury', 'fall_dead_from_abdominal_injury'],
  [189, 'dying_backwards', 'dying_backwards'],
  [190, 'Knock_Down_1', 'knock_down_1'],
  [191, 'Left_Jab_from_Guard', 'left_jab_from_guard'],
  [192, 'Right_Jab_from_Guard', 'right_jab_from_guard'],
  [193, 'Left_Hook_from_Guard', 'left_hook_from_guard'],
  [194, 'Right_Uppercut_from_Guard', 'right_uppercut_from_guard'],
  [195, 'Right_Upper_Hook_from_Guard', 'right_upper_hook_from_guard'],
  [196, 'Left_Uppercut_from_Guard', 'left_uppercut_from_guard'],
  [197, 'Left_Short_Hook_from_Guard', 'left_short_hook_from_guard'],
  [198, 'Punch_Combo', 'punch_combo'],
  [199, 'Weapon_Combo', 'weapon_combo'],
  [200, 'Punch_Combo_1', 'punch_combo_1'],
  [201, 'Punch_Combo_2', 'punch_combo_2'],
  [202, 'Weapon_Combo_1', 'weapon_combo_1'],
  [203, 'Punch_Combo_3', 'punch_combo_3'],
  [204, 'Punch_Combo_4', 'punch_combo_4'],
  [205, 'Punch_Combo_5', 'punch_combo_5'],
  [206, 'Spartan_Kick', 'spartan_kick'],
  [207, 'Roundhouse_Kick', 'roundhouse_kick'],
  [208, 'Lunge_Roundhouse_Kick', 'lunge_roundhouse_kick'],
  [209, 'Boxing_Guard_Right_Straight_Kick', 'boxing_guard_right_straight_kick'],
  [210, 'Boxing_Guard_Prep_Straight_Punch', 'boxing_guard_prep_straight_punch'],
  [211, 'Boxing_Guard_Step_Knee_Strike', 'boxing_guard_step_knee_strike'],
  [212, 'Elbow_Strike', 'elbow_strike'],
  [213, 'Leg_Sweep', 'leg_sweep'],
  [214, 'Punch_Forward_with_Both_Fists', 'punch_forward_with_both_fists'],
  [215, 'High_Kick', 'high_kick'],
  [216, 'Lunge_Spin_Kick', 'lunge_spin_kick'],
  [217, 'Sweeping_Kick', 'sweeping_kick'],
  [218, 'Step_in_High_Kick', 'step_in_high_kick'],
  [219, 'Right_Hand_Sword_Slash', 'right_hand_sword_slash'],
  [220, 'Shield_Push_Left', 'shield_push_left'],
  [221, 'Charged_Upward_Slash', 'charged_upward_slash'],
  [222, 'Draw_and_Shoot_from_Back', 'draw_and_shoot_from_back'],
  [223, 'Draw_and_Shoot_from_Back_1', 'draw_and_shoot_from_back_1'],
  [224, 'Archery_Shot', 'archery_shot'],
  [225, 'Archery_Shot_1', 'archery_shot_1'],
  [226, 'Archery_Shot_2', 'archery_shot_2'],
  [227, 'Archery_Shot_3', 'archery_shot_3'],
  [228, 'Walk_Forward_with_Bow_Aimed', 'walk_forward_with_bow_aimed'],
  [229, 'Draw_and_Shoot_from_Back_2', 'draw_and_shoot_from_back_2'],
  [230, 'Walk_Backward_with_Bow_Aimed', 'walk_backward_with_bow_aimed'],
  [231, 'Archery_Aim_with_Lateral_Scan', 'archery_aim_with_lateral_scan'],
  [232, 'Cowboy_Quick_Draw_Shooting', 'cowboy_quick_draw_shooting'],
  [233, 'Walk_Backward_While_Shooting', 'walk_backward_while_shooting'],
  [234, 'Walk_Forward_While_Shooting', 'walk_forward_while_shooting'],
  [235, 'Forward_Roll_and_Fire', 'forward_roll_and_fire'],
  [236, 'Draw_and_Shoot_Left', 'draw_and_shoot_left'],
  [237, 'Charged_Axe_Chop', 'charged_axe_chop'],
  [238, 'Axe_Spin_Attack', 'axe_spin_attack'],
  [239, 'Crouch_Pull_and_Throw', 'crouch_pull_and_throw'],
  [240, 'Thrust_Slash', 'thrust_slash'],
  [241, 'Weapon_Combo_2', 'weapon_combo_2'],
  [242, 'Charged_Slash', 'charged_slash'],
  [243, 'Idle_3', 'idle_3'],
  [244, 'Idle_4', 'idle_4'],
  [245, 'Idle_5', 'idle_5'],
  [246, 'Idle_6', 'idle_6'],
  [247, 'Idle_7', 'idle_7'],
  [248, 'Idle_8', 'idle_8'],
  [249, 'Idle_9', 'idle_9'],
  [250, 'Idle_10', 'idle_10'],
  [251, 'Idle_11', 'idle_11'],
  [252, 'Idle_12', 'idle_12'],
  [253, 'Idle_13', 'idle_13'],
  [254, 'Idle_14', 'idle_14'],
  [255, 'Angry_Ground_Stomp', 'angry_ground_stomp'],
  [256, 'Angry_Ground_Stomp_1', 'angry_ground_stomp_1'],
  [257, 'Angry_Ground_Stomp_2', 'angry_ground_stomp_2'],
  [258, 'CrouchLookAroundBow', 'crouch_look_around_bow'],
  [259, 'Step_Forward_and_Push', 'step_forward_and_push'],
  [260, 'Push_Forward_and_Stop', 'push_forward_and_stop'],
  [261, 'Push_and_Walk_Forward', 'push_and_walk_forward'],
  [262, 'Crouch_and_Push_Forward', 'crouch_and_push_forward'],
  [263, 'Sleep_on_Desk', 'sleep_on_desk'],
  [264, 'Cough_While_Sleeping', 'cough_while_sleeping'],
  [265, 'Groan_Holding_Stomach_in_Sleep', 'groan_holding_stomach_in_sleep'],
  [266, 'Lie_Down_Hands_Spread', 'lie_down_hands_spread'],
  [267, 'Sleep_Normally', 'sleep_normally'],
  [268, 'Sit_and_Doze_Off', 'sit_and_doze_off'],
  [269, 'sleep', 'sleep'],
  [270, 'Toss_and_Turn', 'toss_and_turn'],
  [271, 'Wake_Up_and_Look_Up', 'wake_up_and_look_up'],
  [272, 'Lie_on_Chair_Sunbathe_and_Sleep', 'lie_on_chair_sunbathe_and_sleep'],
  [273, 'Male_Run_Forward_Pick_Up_Left', 'male_run_forward_pick_up_left'],
  [274, 'Female_Crouch_Pick_Up_Place_Side', 'female_crouch_pick_up_place_side'],
  [275, 'Female_Run_Forward_Pick_Up_Right', 'female_run_forward_pick_up_right'],
  [276, 'Male_Bend_Over_Pick_Up', 'male_bend_over_pick_up'],
  [277, 'Female_Crouch_Pick_Fruit_Basket_Stand', 'female_crouch_pick_fruit_basket_stand'],
  [278, 'Female_Stand_Pick_Fruit_Basket', 'female_stand_pick_fruit_basket'],
  [279, 'Female_Crouch_Pick_Gun_Point_Forward', 'female_crouch_pick_gun_point_forward'],
  [280, 'Female_Crouch_Pick_Throw_Forward', 'female_crouch_pick_throw_forward'],
  [281, 'Female_Bend_Over_Pick_Up_Inspect', 'female_bend_over_pick_up_inspect'],
  [282, 'Female_Walk_Pick_Put_In_Pocket', 'female_walk_pick_put_in_pocket'],
  [283, 'Pull_Radish', 'pull_radish'],
  [284, 'Collect_Object', 'collect_object'],
  [285, 'open_door', 'open_door'],
  [286, 'open_door_1', 'open_door_1'],
  [287, 'open_door_2', 'open_door_2'],
  [288, 'open_door_3', 'open_door_3'],
  [289, 'open_door_4', 'open_door_4'],
  [290, 'Wave_One_Hand', 'wave_one_hand'],
  [291, 'Wave_for_Help', 'wave_for_help'],
  [292, 'Gesture_with_Hand_on_Gun', 'gesture_with_hand_on_gun'],
  [293, 'Wave_for_Help_1', 'wave_for_help_1'],
  [294, 'Wave_for_Help_2', 'wave_for_help_2'],
  [295, 'Wave_for_Help_3', 'wave_for_help_3'],
  [296, 'Wave_for_Help_4', 'wave_for_help_4'],
  [297, 'Personalized_Gesture', 'personalized_gesture'],
  [298, 'Cheer_with_Both_Hands_Up', 'cheer_with_both_hands_up'],
  [299, 'Stand_Clap_and_Sit_Down', 'stand_clap_and_sit_down'],
  [300, 'Sit_Cheer_with_Left_Hand', 'sit_cheer_with_left_hand'],
  [301, 'Cheer_with_Both_Hands_1', 'cheer_with_both_hands_1'],
  [302, 'Stand_Wave_and_Sit_Down', 'stand_wave_and_sit_down'],
  [303, 'Cheer_with_Both_Hands', 'cheer_with_both_hands'],
  [304, 'Seated_Fist_Pump', 'seated_fist_pump'],
  [305, 'Stand_Cheer_and_Sit_Down', 'stand_cheer_and_sit_down'],
  [306, 'Cheer_with_One_Hand_Up', 'cheer_with_one_hand_up'],
  [307, 'Sitting_Answering_Questions', 'sitting_answering_questions'],
  [308, 'Talk_Passionately', 'talk_passionately'],
  [309, 'Talk_with_Left_Hand_on_Hip', 'talk_with_left_hand_on_hip'],
  [310, 'Talk_with_Left_Hand_Raised', 'talk_with_left_hand_raised'],
  [311, 'Stand_Talking_Angry', 'stand_talking_angry'],
  [312, 'Phone_Conversation', 'phone_conversation'],
  [313, 'Talk_with_Hands_Open', 'talk_with_hands_open'],
  [314, 'Talk_with_Right_Hand_Open', 'talk_with_right_hand_open'],
  [315, 'Hand_on_Hip_Gesture', 'hand_on_hip_gesture'],
  [316, 'Headache_Relief', 'headache_relief'],
  [317, 'Shrug', 'shrug'],
  [318, 'Scheming_Hand_Rub', 'scheming_hand_rub'],
  [319, 'air_squat', 'air_squat'],
  [320, 'bicep_curl', 'bicep_curl'],
  [321, 'bicycle_crunch', 'bicycle_crunch'],
  [322, 'circle_crunch', 'circle_crunch'],
  [323, 'golf_drive', 'golf_drive'],
  [324, 'idle_to_push_up', 'idle_to_push_up'],
  [325, 'jump_push_up', 'jump_push_up'],
  [326, 'jumping_jacks', 'jumping_jacks'],
  [327, 'kettlebell_swing', 'kettlebell_swing'],
  [328, 'push_up_to_idle', 'push_up_to_idle'],
  [329, 'push_up', 'push_up'],
  [330, 'situps', 'situps'],
  [331, 'Sumo_High_Pull', 'sumo_high_pull'],
  [333, 'Look_Around_Dumbfounded', 'look_around_dumbfounded'],
  [334, 'Lower_Weapon_Look_Raise', 'lower_weapon_look_raise'],
  [335, 'Axe_Breathe_and_Look_Around', 'axe_breathe_and_look_around'],
  [336, 'Long_Breathe_and_Look_Around', 'long_breathe_and_look_around'],
  [337, 'Torch_Look_Around', 'torch_look_around'],
  [338, 'Short_Breathe_and_Look_Around', 'short_breathe_and_look_around'],
  [339, 'Walking_Scan_with_Sudden_Look_Back', 'walking_scan_with_sudden_look_back'],
  [340, 'Crawl_and_Look_Back', 'crawl_and_look_back'],
  [341, 'Walk_Slowly_and_Look_Around', 'walk_slowly_and_look_around'],
  [342, 'Stand_and_Drink', 'stand_and_drink'],
  [343, 'Sit_and_Drink', 'sit_and_drink'],
  [344, 'Stand_Up1', 'stand_up1'],
  [345, 'Stand_Up2', 'stand_up2'],
  [346, 'Stand_Up3', 'stand_up3'],
  [347, 'Stand_Up4', 'stand_up4'],
  [348, 'Stand_Up5', 'stand_up5'],
  [349, 'Stand_Up6', 'stand_up6'],
  [350, 'Stand_Up7', 'stand_up7'],
  [351, 'Stand_Up8', 'stand_up8'],
  [352, 'Stand_Up9', 'stand_up9'],
  [353, 'Stand_Up10', 'stand_up10'],
  [354, 'Sitting_Clap', 'sitting_clap'],
  [355, 'Sit_Finger_Wag_No', 'sit_finger_wag_no'],
  [356, 'Sit_Hands_on_Head_Lean_Back', 'sit_hands_on_head_lean_back'],
  [357, 'Sit_Thumbs_Up_Right', 'sit_thumbs_up_right'],
  [358, 'Sit_Shout_Hands_on_Mouth', 'sit_shout_hands_on_mouth'],
  [359, 'Look_Back_and_Sit', 'look_back_and_sit'],
  [360, 'Sit_to_standTransition_Female_2', 'sit_to_stand_transition_female_2'],
  [361, 'Sit_Dodge', 'sit_dodge'],
  [362, 'Sit_Cross_Legged', 'sit_cross_legged'],
  [363, 'Sit_Cross_Legged_on_Floor', 'sit_cross_legged_on_floor'],
  [364, 'Sit_on_Chair_Arms_Crossed', 'sit_on_chair_arms_crossed'],
  [365, 'Kneel_on_One_Knee_and_Stand', 'kneel_on_one_knee_and_stand'],
  [366, 'falling_down', 'falling_down'],
  [367, 'SideLying_Reach_Help', 'side_lying_reach_help'],
  [368, 'Angry_To_Tantrum_Sit', 'angry_to_tantrum_sit'],
  [369, 'Lie_Back_Leg_Swing', 'lie_back_leg_swing'],
  [370, 'Stand_To_Side_Lying', 'stand_to_side_lying'],
  [371, 'Sit_Lie_Bed', 'sit_lie_bed'],
  [372, 'Prone_Reach_Help', 'prone_reach_help'],
  [375, 'Handstand_Flip', 'handstand_flip'],
  [376, 'Punch_Pose', 'punch_pose'],
  [377, 'Relax_arms_then_strike_battle_pose', 'relax_arms_then_strike_battle_pose'],
  [378, 'Large_step_then_high_kick', 'large_step_then_high_kick'],
  [379, 'Side_jumps_in_horse_stance', 'side_jumps_in_horse_stance'],
  [381, 'Step_Right_for_Exercise', 'step_right_for_exercise'],
  [382, 'Jump_and_Slam_Back_Down', 'jump_and_slam_back_down'],
  [384, 'Quick_Step_and_Spin_Dodge', 'quick_step_and_spin_dodge'],
  [385, 'Boxing_Warmup', 'boxing_warmup'],
  [386, 'Zombie_Scream', 'zombie_scream'],
  [387, 'Half_Squat_with_Thumb_Up', 'half_squat_with_thumb_up'],
  [388, 'Show_Both_Arm_Muscles', 'show_both_arm_muscles'],
  [389, 'Grip_and_Throw_Down', 'grip_and_throw_down'],
  [390, 'Stand_on_Pole_and_Balance', 'stand_on_pole_and_balance'],
  [391, 'Head_Hold_in_Pain', 'head_hold_in_pain'],
  [392, 'Ground_Flip_and_Sweep_Up', 'ground_flip_and_sweep_up'],
  [393, 'baseball_pitching', 'baseball_pitching'],
  [394, 'Backflip_and_Hooks', 'backflip_and_hooks'],
  [395, 'Breakdance_1990', 'breakdance_1990'],
  [396, 'Burpee_Exercise', 'burpee_exercise'],
  [397, '360_Power_Spin_Jump', '360_power_spin_jump'],
  [398, 'Crouch_Charge_and_Throw', 'crouch_charge_and_throw'],
  [399, 'Step_Step_Turn_Kick', 'step_step_turn_kick'],
  [401, 'Sprint_Roll_and_Flip', 'sprint_roll_and_flip'],
  [402, 'Run_and_Leap', 'run_and_leap'],
  [403, 'Victory_Fist_Pump', 'victory_fist_pump'],
  [404, 'Crouch_and_Step_Back', 'crouch_and_step_back'],
  [405, 'Joyful_Dance_with_Hand_Sway', 'joyful_dance_with_hand_sway'],
  [406, 'Thomas_Flair_to_Jump_Up', 'thomas_flair_to_jump_up'],
  [407, 'Wall_Push_Jump_and_Flip', 'wall_push_jump_and_flip'],
  [408, 'Jazz_Hands', 'jazz_hands'],
  [409, 'Finger_Wag_No', 'finger_wag_no'],
  [410, 'Kick_a_Soccer_Ball', 'kick_a_soccer_ball'],
  [411, 'Neck_Slashing_Gesture', 'neck_slashing_gesture'],
  [412, 'victory', 'victory'],
  [413, 'Backflip_and_Rise', 'backflip_and_rise'],
  [414, 'Double_kick_forward', 'double_kick_forward'],
  [415, 'Happy_Sway_Standing', 'happy_sway_standing'],
  [416, 'Hit_in_Back_While_Running', 'hit_in_back_while_running'],
  [417, 'Hop_with_Arms_Raised', 'hop_with_arms_raised'],
  [419, 'Jump_to_Catch_and_Fall', 'jump_to_catch_and_fall'],
  [420, 'Left_Hand_Bitten_Step_Back', 'left_hand_bitten_step_back'],
  [421, 'Over_Shoulder_Throw', 'over_shoulder_throw'],
  [422, 'Rising_Flying_Kick', 'rising_flying_kick'],
  [425, 'Vault_with_Rifle', 'vault_with_rifle'],
  [426, 'Roll_Behind_Cover', 'roll_behind_cover'],
  [427, 'Vault_and_Land', 'vault_and_land'],
  [428, 'Unarmed_Vault', 'unarmed_vault'],
  [429, 'Parkour_Vault', 'parkour_vault'],
  [430, 'Parkour_Vault_with_Roll', 'parkour_vault_with_roll'],
  [431, 'Parkour_Vault_1', 'parkour_vault_1'],
  [432, 'Parkour_Vault_2', 'parkour_vault_2'],
  [433, 'Parkour_Vault_3', 'parkour_vault_3'],
  [434, 'Fast_Ladder_Climb', 'fast_ladder_climb'],
  [435, 'Ladder_Climb_Finish', 'ladder_climb_finish'],
  [436, 'Ladder_Mount_Start', 'ladder_mount_start'],
  [437, 'Slow_Ladder_Climb', 'slow_ladder_climb'],
  [438, 'Ladder_Climb_Loop', 'ladder_climb_loop'],
  [439, 'Climb_Left_with_Both_Limbs', 'climb_left_with_both_limbs'],
  [440, 'Climb_Right_with_Both_Limbs', 'climb_right_with_both_limbs'],
  [441, 'Climb_Stairs', 'climb_stairs'],
  [442, 'Fast_Stair_Climb', 'fast_stair_climb'],
  [444, 'climbing_up_wall', 'climbing_up_wall'],
  [445, 'diagonal_wall_run', 'diagonal_wall_run'],
  [446, 'Hang_and_Climb_Left', 'hang_and_climb_left'],
  [447, 'Hang_and_Climb_Rght', 'hang_and_climb_rght'],
  [448, 'Jump_and_Grab_Wall', 'jump_and_grab_wall'],
  [449, 'Climb_Up_Rope', 'climb_up_rope'],
  [450, 'Wall_Flip', 'wall_flip'],
  [451, 'One_Arm_Handstand', 'one_arm_handstand'],
  [452, 'Backflip', 'backflip'],
  [453, 'Backflip_Sweep_Kick', 'backflip_sweep_kick'],
  [455, 'Sweep_Kick', 'sweep_kick'],
  [456, 'Jumping_Head_Scissor_Takedown', 'jumping_head_scissor_takedown'],
  [457, 'Jumping_Punch', 'jumping_punch'],
  [458, 'Unicycle_Jump_Dismount', 'unicycle_jump_dismount'],
  [459, 'Run_Jump_and_Roll', 'run_jump_and_roll'],
  [460, 'Jump_with_Arms_Open', 'jump_with_arms_open'],
  [461, 'Jump_with_Arms_and_Legs_Open', 'jump_with_arms_and_legs_open'],
  [462, 'Backflip_Jump', 'backflip_jump'],
  [463, 'Run_and_Jump', 'run_and_jump'],
  [464, 'Leap_and_Punch', 'leap_and_punch'],
  [465, 'Leap_Right_and_Catch', 'leap_right_and_catch'],
  [466, 'Regular_Jump', 'regular_jump'],
  [467, 'Jump_Over_Obstacle_2', 'jump_over_obstacle_2'],
  [468, 'Back_Jump', 'back_jump'],
  [470, 'Jumping_Down', 'jumping_down'],
  [471, 'Jump_Over_Obstacle', 'jump_over_obstacle'],
  [472, 'Jump_Over_Obstacle_1', 'jump_over_obstacle_1'],
  [473, 'Quad_Jump_Left', 'quad_jump_left'],
  [474, 'Quad_Jump_Up', 'quad_jump_up'],
  [475, 'Quad_Climb_Right', 'quad_climb_right'],
  [476, 'Hang_and_Push_with_Foot', 'hang_and_push_with_foot'],
  [477, 'Rope_Hang_Idle', 'rope_hang_idle'],
  [478, 'Bar_Hang_Idle', 'bar_hang_idle'],
  [479, 'Upside_Down_Rope_Hang', 'upside_down_rope_hang'],
  [480, 'Upside_Down_Rope_Hang_1', 'upside_down_rope_hang_1'],
  [481, 'Upside_Down_Rope_Hang_2', 'upside_down_rope_hang_2'],
  [482, 'Grab_Wall_Midair_Idle', 'grab_wall_midair_idle'],
  [483, 'Slow_Bar_Hang_Left', 'slow_bar_hang_left'],
  [484, 'Slow_Bar_Hang_Right', 'slow_bar_hang_right'],
  [485, 'Jump_and_Hang_on_Bar', 'jump_and_hang_on_bar'],
  [486, 'Wall_Support_to_Step_Down', 'wall_support_to_step_down'],
  [487, 'Climb_Attempt_and_Fall_3', 'climb_attempt_and_fall_3'],
  [488, 'Climb_Attempt_and_Fall_4', 'climb_attempt_and_fall_4'],
  [489, 'Climb_Attempt_and_Fall_5', 'climb_attempt_and_fall_5'],
  [490, 'Fall_Down', 'fall_down'],
  [491, 'Fall_from_Bar', 'fall_from_bar'],
  [492, 'Wall_Support_Jump_to_Ground', 'wall_support_jump_to_ground'],
  [493, 'Jump_Down_from_Wall', 'jump_down_from_wall'],
  [494, 'Swing_on_Rope_to_Ground', 'swing_on_rope_to_ground'],
  [495, 'Grab_Bar_and_Swing_Forward', 'grab_bar_and_swing_forward'],
  [496, 'Rope_Hang_Backflip_to_Crouch', 'rope_hang_backflip_to_crouch'],
  [497, 'climbing_down_wall', 'climbing_down_wall'],
  [498, 'Climb_Attempt_and_Fall', 'climb_attempt_and_fall'],
  [499, 'Climb_Attempt_and_Fall_1', 'climb_attempt_and_fall_1'],
  [500, 'Climb_Attempt_and_Fall_2', 'climb_attempt_and_fall_2'],
  [501, 'Leap_of_Faith', 'leap_of_faith'],
  [502, 'Fall1', 'fall1'],
  [503, 'Fall2', 'fall2'],
  [504, 'Fall3', 'fall3'],
  [505, 'Fall4', 'fall4'],
  [506, 'Dive_Down_and_Land', 'dive_down_and_land'],
  [507, 'Dive_Down_and_Land_1', 'dive_down_and_land_1'],
  [508, 'Dive_Down_and_Land_2', 'dive_down_and_land_2'],
  [509, 'Lean_Forward_Sprint', 'lean_forward_sprint'],
  [510, 'Standard_Forward_Charge', 'standard_forward_charge'],
  [511, 'Rifle_Charge', 'rifle_charge'],
  [512, 'Male_Head_Down_Charge', 'male_head_down_charge'],
  [513, 'Female_Head_Down_Charge', 'female_head_down_charge'],
  [514, 'Female_Bow_Charge_Left_Hand', 'female_bow_charge_left_hand'],
  [515, 'Female_Throwing_Stance_Charge', 'female_throwing_stance_charge'],
  [516, 'slide_light', 'slide_light'],
  [517, 'slide_right', 'slide_right'],
  [518, 'sliding_rool', 'sliding_rool'],
  [519, 'sliding_stumble', 'sliding_stumble'],
  [520, 'Crouch_Walk_with_Torch', 'crouch_walk_with_torch'],
  [521, 'Crouch_Walk_Left_with_Torch', 'crouch_walk_left_with_torch'],
  [522, 'Crouch_Walk_Right_with_Torch', 'crouch_walk_right_with_torch'],
  [523, 'Cautious_Crouch_Walk_Backward', 'cautious_crouch_walk_backward'],
  [524, 'Cautious_Crouch_Walk_Forward', 'cautious_crouch_walk_forward'],
  [525, 'Cautious_Crouch_Walk_Left', 'cautious_crouch_walk_left'],
  [526, 'Cautious_Crouch_Walk_Right', 'cautious_crouch_walk_right'],
  [527, 'Crouch_Walk_Left_with_Gun', 'crouch_walk_left_with_gun'],
  [528, 'Walk_Left_with_Gun', 'walk_left_with_gun'],
  [529, 'Walk_Backward_with_Gun', 'walk_backward_with_gun'],
  [530, 'run_fast_3', 'run_fast_3'],
  [531, 'Sprint_and_Sudden_Stop', 'sprint_and_sudden_stop'],
  [532, 'run_fast_4', 'run_fast_4'],
  [533, 'run_fast_5', 'run_fast_5'],
  [534, 'run_fast_6', 'run_fast_6'],
  [535, 'run_fast_7', 'run_fast_7'],
  [536, 'run_fast_8', 'run_fast_8'],
  [537, 'run_fast_9', 'run_fast_9'],
  [538, 'run_fast_10', 'run_fast_10'],
  [539, 'run_fast_2', 'run_fast_2'],
  [540, 'Injured_Walk_Backward', 'injured_walk_backward'],
  [541, 'Walk_Backward_with_Gun_1', 'walk_backward_with_gun_1'],
  [542, 'Walk_Backward_with_Grenade', 'walk_backward_with_grenade'],
  [543, 'Step_Back', 'step_back'],
  [544, 'Walk_Backward', 'walk_backward'],
  [545, 'Walk_Backward_with_Bow', 'walk_backward_with_bow'],
  [546, 'Walk_Backward_with_Sword', 'walk_backward_with_sword'],
  [547, 'Walk_Backward_with_Bow_1', 'walk_backward_with_bow_1'],
  [548, 'Walk_Backward_with_Sword_Shield', 'walk_backward_with_sword_shield'],
  [549, 'Crawl_Backward', 'crawl_backward'],
  [550, 'Carry_Heavy_Cannon_Forward', 'carry_heavy_cannon_forward'],
  [551, 'Carry_Heavy_Object_Walk', 'carry_heavy_object_walk'],
  [552, 'Carry_Water_Bucket_Walk', 'carry_water_bucket_walk'],
  [553, 'Elderly_Shaky_Walk', 'elderly_shaky_walk'],
  [554, 'Funky_Walk', 'funky_walk'],
  [555, 'Limping_Walk_1', 'limping_walk_1'],
  [556, 'Limping_Walk_2', 'limping_walk_2'],
  [557, 'Limping_Walk_3', 'limping_walk_3'],
  [558, 'Limping_Walk', 'limping_walk'],
  [559, 'Sneaky_Walk', 'sneaky_walk'],
  [560, 'Spear_Walk', 'spear_walk'],
  [561, 'Step_Hip_Hop_Dance', 'step_hip_hop_dance'],
  [562, 'Stumble_Walk', 'stumble_walk'],
  [563, 'Stylish_Walk', 'stylish_walk'],
  [564, 'Tightrope_Walk', 'tightrope_walk'],
  [565, 'Walk_with_Umbrella', 'walk_with_umbrella'],
  [566, 'walking_2', 'walking_2'],
  [567, 'Walk_with_Walker_Support', 'walk_with_walker_support'],
  [568, 'Swim_Idle', 'swim_idle'],
  [569, 'Swim_Forward', 'swim_forward'],
  [570, 'swimming_to_edge', 'swimming_to_edge'],
  [571, 'Run_Turn_Left', 'run_turn_left'],
  [572, 'Walk_Turn_Left', 'walk_turn_left'],
  [573, 'Rifle_Turn_Left', 'rifle_turn_left'],
  [574, 'Walk_Turn_Left_with_Weapon', 'walk_turn_left_with_weapon'],
  [575, 'Combat_Idle_Turn_Left', 'combat_idle_turn_left'],
  [576, 'Idle_Turn_Left', 'idle_turn_left'],
  [577, 'Idle_Step_Turn_Left', 'idle_step_turn_left'],
  [578, 'Idle_Torch_Turn_Left', 'idle_torch_turn_left'],
  [579, 'Depressed_Full_Turn_Left', 'depressed_full_turn_left'],
  [580, 'Sword_and_Shield_Alert_Turn_Left', 'sword_and_shield_alert_turn_left'],
  [581, 'Run_Sharp_Turn_Right', 'run_sharp_turn_right'],
  [582, 'Run_Turn_Right', 'run_turn_right'],
  [583, 'Walk_Turn_Right', 'walk_turn_right'],
  [584, 'Walk_Turn_Right_Female', 'walk_turn_right_female'],
  [585, 'Rifle_Aim_Turn_Right', 'rifle_aim_turn_right'],
  [586, 'Idle_Turn_Right', 'idle_turn_right'],
  [587, 'Walk_Turn_Right_Idle_Style', 'walk_turn_right_idle_style'],
  [588, 'Frustrated_Turn_Right', 'frustrated_turn_right'],
  [589, 'Alert_Quick_Turn_Right', 'alert_quick_turn_right'],
  [590, 'Sword_and_Shield_Alert_Turn_Right', 'sword_and_shield_alert_turn_right'],
  [591, 'Hip_Hop_Dance', 'hip_hop_dance'],
  [592, 'Hip_Hop_Dance_1', 'hip_hop_dance_1'],
  [593, 'Hip_Hop_Dance_2', 'hip_hop_dance_2'],
  [594, 'Hip_Hop_Dance_3', 'hip_hop_dance_3'],
  [595, 'jazz_danc', 'jazz_danc'],
  [596, 'ymca_dance', 'ymca_dance'],
  [597, 'Hip_Hop_Dance_4', 'hip_hop_dance_4'],
  [598, 'kettlebell_swing_1', 'kettlebell_swing_1'],
  [599, 'Idle_15', 'idle_15'],
  [601, 'Backflip_inplace', 'backflip_inplace'],
  [604, 'Backflip_Sweep_Kick_inplace', 'backflip_sweep_kick_inplace'],
  [605, 'Back_Jump_inplace', 'back_jump_inplace'],
  [606, 'BackLeft_run_inplace', 'back_left_run_inplace'],
  [607, 'BackRight_Run_inplace', 'back_right_run_inplace'],
  [608, 'BeHit_FlyUp_inplace', 'be_hit_fly_up_inplace'],
  [609, 'Boxing_Practice_inplace', 'boxing_practice_inplace'],
  [610, 'Carry_Heavy_Cannon_Forward_inplace', 'carry_heavy_cannon_forward_inplace'],
  [611, 'Carry_Heavy_Object_Walk_inplace', 'carry_heavy_object_walk_inplace'],
  [612, 'Carry_Water_Bucket_Walk_inplace', 'carry_water_bucket_walk_inplace'],
  [613, 'Casual_Walk_inplace', 'casual_walk_inplace'],
  [615, 'Cautious_Crouch_Walk_Backward_inplace', 'cautious_crouch_walk_backward_inplace'],
  [616, 'Cautious_Crouch_Walk_Forward_inplace', 'cautious_crouch_walk_forward_inplace'],
  [617, 'Cautious_Crouch_Walk_Left_inplace', 'cautious_crouch_walk_left_inplace'],
  [618, 'Cautious_Crouch_Walk_Right_inplace', 'cautious_crouch_walk_right_inplace'],
  [619, 'Climb_Left_with_Both_Limbs_inplace', 'climb_left_with_both_limbs_inplace'],
  [620, 'Climb_Right_with_Both_Limbs_inplace', 'climb_right_with_both_limbs_inplace'],
  [621, 'Confident_Strut_inplace', 'confident_strut_inplace'],
  [622, 'Crawl_Backward_inplace', 'crawl_backward_inplace'],
  [623, 'Crouch_Walk_Left_with_Gun_inplace', 'crouch_walk_left_with_gun_inplace'],
  [624, 'Crouch_Walk_Left_with_Torch_inplace', 'crouch_walk_left_with_torch_inplace'],
  [625, 'Crouch_Walk_Right_with_Torch_inplace', 'crouch_walk_right_with_torch_inplace'],
  [626, 'Elderly_Shaky_Walk_inplace', 'elderly_shaky_walk_inplace'],
  [627, 'Female_Bow_Charge_Left_Hand_inplace', 'female_bow_charge_left_hand_inplace'],
  [628, 'Female_Throwing_Stance_Charge_inplace', 'female_throwing_stance_charge_inplace'],
  [629, 'Flirty_Strut_inplace', 'flirty_strut_inplace'],
  [630, 'ForwardLeft_Run_Fight_inplace', 'forward_left_run_fight_inplace'],
  [631, 'ForwardRight_Run_Fight_inplace', 'forward_right_run_fight_inplace'],
  [632, 'Funky_Walk_inplace', 'funky_walk_inplace'],
  [635, 'Handbag_Walk_inplace', 'handbag_walk_inplace'],
  [636, 'Hello_Run_inplace', 'hello_run_inplace'],
  [637, 'Injured_Walk_inplace', 'injured_walk_inplace'],
  [638, 'Injured_Walk_Backward_inplace', 'injured_walk_backward_inplace'],
  [639, 'Jazz_Hands_inplace', 'jazz_hands_inplace'],
  [640, 'Jump_Over_Obstacle_inplace', 'jump_over_obstacle_inplace'],
  [641, 'Jump_Over_Obstacle_1_inplace', 'jump_over_obstacle_1_inplace'],
  [642, 'Jump_Over_Obstacle_2_inplace', 'jump_over_obstacle_2_inplace'],
  [643, 'Jump_Run_inplace', 'jump_run_inplace'],
  [644, 'Lean_Forward_Sprint_inplace', 'lean_forward_sprint_inplace'],
  [645, 'Limping_Walk_inplace', 'limping_walk_inplace'],
  [646, 'Limping_Walk_1_inplace', 'limping_walk_1_inplace'],
  [647, 'Limping_Walk_2_inplace', 'limping_walk_2_inplace'],
  [648, 'Limping_Walk_3_inplace', 'limping_walk_3_inplace'],
  [649, 'Lunge_Roundhouse_Kick_inplace', 'lunge_roundhouse_kick_inplace'],
  [650, 'Mummy_Stagger_inplace', 'mummy_stagger_inplace'],
  [651, 'Parkour_Vault_with_Roll_inplace', 'parkour_vault_with_roll_inplace'],
  [652, 'Proud_Strut_inplace', 'proud_strut_inplace'],
  [653, 'Red_Carpet_Walk_inplace', 'red_carpet_walk_inplace'],
  [654, 'Rifle_Charge_inplace', 'rifle_charge_inplace'],
  [656, 'Run_and_Leap_inplace', 'run_and_leap_inplace'],
  [657, 'run_fast_10_inplace', 'run_fast_10_inplace'],
  [658, 'run_fast_2_inplace', 'run_fast_2_inplace'],
  [659, 'run_fast_3_inplace', 'run_fast_3_inplace'],
  [660, 'run_fast_4_inplace', 'run_fast_4_inplace'],
  [661, 'run_fast_5_inplace', 'run_fast_5_inplace'],
  [662, 'run_fast_6_inplace', 'run_fast_6_inplace'],
  [663, 'run_fast_7_inplace', 'run_fast_7_inplace'],
  [664, 'run_fast_8_inplace', 'run_fast_8_inplace'],
  [665, 'run_fast_9_inplace', 'run_fast_9_inplace'],
  [666, 'Running_Reload_inplace', 'running_reload_inplace'],
  [667, 'Run_to_Walk_Transition_inplace', 'run_to_walk_transition_inplace'],
  [668, 'Skip_Forward_inplace', 'skip_forward_inplace'],
  [669, 'Slow_Orc_Walk_inplace', 'slow_orc_walk_inplace'],
  [670, 'Slow_Walk_Reload_inplace', 'slow_walk_reload_inplace'],
  [671, 'Sneaky_Walk_inplace', 'sneaky_walk_inplace'],
  [672, 'Spear_Walk_inplace', 'spear_walk_inplace'],
  [673, 'Standard_Forward_Charge_inplace', 'standard_forward_charge_inplace'],
  [674, 'Stumble_Walk_inplace', 'stumble_walk_inplace'],
  [675, 'Stylish_Walk_inplace', 'stylish_walk_inplace'],
  [676, 'Texting_Walk_inplace', 'texting_walk_inplace'],
  [677, 'Tightrope_Walk_inplace', 'tightrope_walk_inplace'],
  [678, 'Unsteady_Walk_inplace', 'unsteady_walk_inplace'],
  [679, 'Walk_Backward_inplace', 'walk_backward_inplace'],
  [680, 'Walk_Backward_While_Shooting_inplace', 'walk_backward_while_shooting_inplace'],
  [681, 'Walk_Backward_with_Bow_inplace', 'walk_backward_with_bow_inplace'],
  [682, 'Walk_Backward_with_Bow_1_inplace', 'walk_backward_with_bow_1_inplace'],
  [683, 'Walk_Backward_with_Bow_Aimed_inplace', 'walk_backward_with_bow_aimed_inplace'],
  [684, 'Walk_Backward_with_Grenade_inplace', 'walk_backward_with_grenade_inplace'],
  [685, 'Walk_Backward_with_Gun_inplace', 'walk_backward_with_gun_inplace'],
  [686, 'Walk_Backward_with_Gun_1_inplace', 'walk_backward_with_gun_1_inplace'],
  [687, 'Walk_Backward_with_Sword_inplace', 'walk_backward_with_sword_inplace'],
  [688, 'Walk_Fight_Back_inplace', 'walk_fight_back_inplace'],
  [689, 'Walk_Fight_Forward_inplace', 'walk_fight_forward_inplace'],
  [690, 'Walk_Forward_While_Shooting_inplace', 'walk_forward_while_shooting_inplace'],
  [691, 'Walk_Forward_with_Bow_Aimed_inplace', 'walk_forward_with_bow_aimed_inplace'],
  [692, 'walking_2_inplace', 'walking_2_inplace'],
  [693, 'Walking_with_Phone_inplace', 'walking_with_phone_inplace'],
  [694, 'Walk_Left_with_Gun_inplace', 'walk_left_with_gun_inplace'],
  [695, 'Walk_with_Umbrella_inplace', 'walk_with_umbrella_inplace'],
  [696, 'Walk_with_Walker_Support_inplace', 'walk_with_walker_support_inplace'],
]

// Meshy marks the stationary variant of a clip with a trailing "inplace"
// ("back_jump_inplace"). It qualifies the base name rather than continuing it,
// so it is lifted out of the word run and appended in brackets.
const IN_PLACE_SUFFIX = /_inplace$/

// "funny_dancing_01" reads as "Funny dancing 1": words lowercased after the
// first, zero-padding dropped and digits split off a word they are glued to.
const displayNameFor = (fileName) => {
  const base = fileName
    .replace(IN_PLACE_SUFFIX, '')
    .replace(/([a-z])(\d)/g, '$1_$2')
    .split('_')
    .map(word => word.replace(/^0+(?=\d)/, ''))
    .join(' ')
    .replace(/^./, first => first.toUpperCase())

  return IN_PLACE_SUFFIX.test(fileName) ? `${base} (in place)` : base
}

export const ANIMATIONS = LIBRARY.map(([actionId, meshyName, fileName]) => ({
  id: fileName,
  name: displayNameFor(fileName),
  actionId,
  tripoPreset: TRIPO_PRESETS[meshyName],
  preview: `${PREVIEW_BASE_URL}/${fileName}.webp`,
}))

const ANIMATIONS_BY_ID = new Map(ANIMATIONS.map(entry => [entry.id, entry]))
const ANIMATIONS_BY_ACTION_ID = new Map(ANIMATIONS.map(entry => [entry.actionId, entry]))
// The idle and run presets are each claimed by two entries, so the reverse
// lookup keeps the first one declared rather than the last.
const ANIMATIONS_BY_TRIPO_PRESET = new Map(
  ANIMATIONS.filter(entry => entry.tripoPreset).reverse().map(entry => [entry.tripoPreset, entry]),
)

/**
 * Looks up a library entry by its local slug.
 *
 * @param {string|null} [id] - ANIMATIONS[].id, e.g. the stored animateSettings.animationId
 * @returns {Object|undefined} - The matching entry, or undefined when nothing is selected
 */
export const findAnimationById = id => ANIMATIONS_BY_ID.get(id)

/**
 * Looks up a library entry by the Meshy numeric library id persisted on a run
 * (provider_run.action_code), so a reopened run can highlight its animation.
 *
 * @param {number|string} [actionId] - Meshy action_id
 * @returns {Object|undefined}
 */
export const findAnimationByActionId = actionId => ANIMATIONS_BY_ACTION_ID.get(Number(actionId))

/**
 * Looks up a library entry by the Tripo3D preset persisted on a run
 * (provider_run.animation).
 *
 * @param {string} [tripoPreset] - Tripo3D preset name, e.g. "preset:walk"
 * @returns {Object|undefined}
 */
export const findAnimationByTripoPreset = tripoPreset => ANIMATIONS_BY_TRIPO_PRESET.get(tripoPreset)
